import { toast, ToastOptions } from 'react-toastify';

import { REACT_TOASTIFY_API_ERROR_ID } from '@/shared/redux/api/base-api.constants';

export const showToastError = (
  message: string,
  options?: Omit<ToastOptions, 'toastId' | 'type'>,
): void => {
  toast.error(message, {
    ...options,
    toastId: REACT_TOASTIFY_API_ERROR_ID,
  });
};

export const showToastSuccess = (
  message: string,
  options?: Omit<ToastOptions, 'toastId' | 'type'>,
): void => {
  toast.success(message, {
    ...options,
    toastId: REACT_TOASTIFY_API_ERROR_ID,
  });
};

export const showToastWarning = (
  message: string,
  options?: Omit<ToastOptions, 'toastId' | 'type'>,
): void => {
  toast.warning(message, {
    ...options,
    toastId: REACT_TOASTIFY_API_ERROR_ID,
  });
};

export const showToastInfo = (
  message: string,
  options?: Omit<ToastOptions, 'toastId' | 'type'>,
): void => {
  toast.info(message, {
    ...options,
    toastId: REACT_TOASTIFY_API_ERROR_ID,
  });
};
